import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EditLocationAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edit_location_alt"}/>
}
